import { render, staticRenderFns } from "./MyOrderCenter.vue?vue&type=template&id=1a8e5c0f&scoped=true&"
import script from "./MyOrderCenter.vue?vue&type=script&lang=js&"
export * from "./MyOrderCenter.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderCenter.vue?vue&type=style&index=0&id=1a8e5c0f&lang=less&scoped=true&"
import style1 from "./MyOrderCenter.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e5c0f",
  null
  
)

export default component.exports